import React, { PureComponent } from 'react'
import Icon from './../Icon'

import './../styles/ListItem.css'

class ListItem extends PureComponent {
  render() {
    const vd = this.props.date.substring(0,2)
    const vm = this.props.date.substring(3,5)
    const vy = this.props.date.substring(6,10)
    const bd = this.props.until.substring(0,2)
    const bm = this.props.until.substring(3,5)
    const by = this.props.until.substring(6,10)
    let date = ''
    if (vd !== bd && vm === bm && vy === by) {
      date = vd + '. - ' + bd + '.' + bm + '.' + by
    }
    else if (vm !== bm && vy === by) {
      date = vd + '.' + vm + '. - ' + bd + '.' + bm + '.' + by
    }
    else if (vy !== by) {
      date = this.props.date + ' - ' + this.props.until
    }
    else {
      date = this.props.date
    }
    let cssListItem = 'listitem'
    if (!!this.props.activeState) {
      cssListItem += ' active'
    }
    if (this.props.publicState === 'CANCELLED') {
      cssListItem += ' cancelled'
    } else if (this.props.publicState === 'CONFIRMED') {
      cssListItem += ' confirmed'
    } else if (this.props.publicState === 'UNCERTAIN') {
      cssListItem += ' uncertain'
    }

    const distance = this.props.distance ? (parseFloat(this.props.distance) / 1000).toFixed(0) : false

    return (
      <div className={cssListItem} onClick={this.props.onClick}>
        <div className="listitem-content">
          {this.props.premium === true && (
            <div className="listitem-premium">
              <span>Premium-Event</span>
            </div>
          )}
          <div className="listitem-topline">
            <div className="listitem-indicator">
              <Icon name={this.props.sport} size="30" color="#649ed6" />
            </div>
            <div className="listitem-name">{this.props.name}</div>
            {
              !!distance &&
              <div style={{whiteSpace: "nowrap"}}><small>{distance} km</small></div>
            }
          </div>
          <div className="listitem-metainfo">
            <div className="listitem-metainfo-block">
              <span>{date}</span>
            </div>
            <div className="listitem-metainfo-block">
              <span>{this.props.location}</span>
            </div>
          </div>
          {/* HERE COMES THE EXTRA CONTENT*/}
          {this.props.activeState === true && (
            <div className="listitem-extrainfo">
              <hr />
              <div className="listitem-extrainfo-block">
                <p className="attendees">
                  <Icon name="person" size="20" color="#888" /> {this.props.attendees} Teilnehmer
                </p>
              </div>
              {/* <div className="listitem-extrainfo-block">
              <p className="distance">
              <Icon name="distance" size="20" color="#888" /> {this.props.distance} entfernt
              </p>
            </div> */}
              <div className="listitem-extrainfo-block">
                <p className="contest">
                  <Icon name="contest" size="20" color="#888" /> {this.props.contests} Wettkämpfe
                </p>
              </div>
              <div className="listitem-extrainfo-block">
                <a class="button-redirect-to-event" href={'https://' + this.props.larasch} target="_top" rel="noopener noreferrer" className="link-button">
                  <span>Weitere Informationen</span>
                  <Icon color="#fff" name="link" size="1rem" />
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default ListItem



// WEBPACK FOOTER //
// ./src/components/parts/ListItem.js